<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="800px">
            <v-card>
                <media-library-toolbar
                        :removeMode="removeMode"
                        :selected="selected"
                ></media-library-toolbar>
                <v-card-title>

                    <!--<v-toolbar flat color="default">
                        <v-toolbar-title>Медиатека</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="blue lighten-2" v-on="on">
                                    <v-icon>help_outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Для загрузки новых файлов нажмите на кнопку "+"<br> и следуйте дальнейшим указаниям</span>
                        </v-tooltip>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="blue lighten-2" v-on="on" @click="updateAllLibrary">
                                    <v-icon>refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Обновить медиатеку</span>
                        </v-tooltip>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon color="blue lighten-2" @click="sendNotification"> &lt;!&ndash;href="https://vk.com/write-23067124" target="_blank" link>&ndash;&gt;
                                    <v-icon>cloud_upload</v-icon>
                                </v-btn>
                            </template>
                            <span>Перейти в диалог группы ВК и залить файлы</span>
                        </v-tooltip>

                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon :large="removeMode" color="blue lighten-2" @click="removeMode = !removeMode" >
                                    <v-icon>delete_outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Выбрать и удалить файлы из медиатеки</span>
                        </v-tooltip>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon :large="removeMode" color="success" @click="removeMode = false"
                                       v-if="removeMode == true">
                                    <v-icon>undo</v-icon>
                                </v-btn>
                            </template>
                            <span>Выйти из режима удаления файлов из медиатеки</span>
                        </v-tooltip>
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon :large="removeMode" color="error" v-if="removeMode === true"
                                       @click="confirmDialog = true" :disabled="selected.length === 0">
                                    <v-icon>delete_sweep</v-icon>
                                </v-btn>
                            </template>
                            <span>Удалить выбранные файлы</span>
                        </v-tooltip>
                    </v-toolbar>-->
                    <v-tabs
                            vertical
                    >
                        <v-tab>
                            <v-flex>
                                <v-badge :overlap="true" bottom left>
                                    <template v-slot:badge>{{mediaItems[0].length}}</template>
                                    <v-icon left large >photo_library</v-icon>
                                </v-badge>
                                Картинки
                            </v-flex>
                        </v-tab>
                        <v-tab>
                            <v-flex>
                                <v-badge :overlap="true" bottom left>
                                    <template v-slot:badge>{{mediaItems[1].length}}</template>
                                    <v-icon left large>movie</v-icon>
                                </v-badge>
                                Видео
                            </v-flex>
                        </v-tab>
                        <v-tab>
                            <v-flex>
                                <v-badge :overlap="true" bottom left>
                                    <template v-slot:badge>{{mediaItems[2].length}}</template>
                                    <v-icon left large>insert_drive_file</v-icon>
                                </v-badge>
                                Документы
                            </v-flex>
                        </v-tab>

                        <v-tab-item
                                v-for="(mediaItem_, indexMedia) in mediaItems"
                                :key="indexMedia"
                        >
                            <v-layout>
                                <v-flex xs12 sm12>
                                    <v-card
                                            max-width="600"
                                            class="mx-auto"
                                            flat
                                    >
                                        <v-container
                                                grid-list-sm
                                                pa-1
                                        >
                                            <v-item-group
                                                    v-model="selected"
                                                    multiple
                                            >
                                                <v-layout wrap>
                                                    <v-flex
                                                            v-for="(mediaItem, index) in mediaItems[indexMedia]"
                                                            :key="index"
                                                            xs12
                                                            md3
                                                            v-show="mediaItem.show === 1"
                                                    >
                                                        <v-flex v-if="removeMode == false">
                                                            <v-img
                                                                    v-if="mediaItem.type < 2 && mediaItem.visible == 1"
                                                                    :src="mediaItem.link"
                                                                    height="120"
                                                                    class="text-right pa-2"
                                                                    @click="selectMedia(indexMedia, index)"
                                                            >
                                                            </v-img>
                                                            <v-card v-else flat @click="selectMedia(indexMedia, index)">
                                                                <v-card-text class="text-truncate pa-1">
                                                                    <p class="text-center mb-1">
                                                                        <v-icon large>insert_drive_file</v-icon>
                                                                    </p>
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on }">
                                                                            <span v-on="on">{{mediaItem.caption}}</span>
                                                                        </template>
                                                                        <span>{{mediaItem.caption}}</span>
                                                                    </v-tooltip>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-flex>
                                                        <v-flex v-if="removeMode == true">
                                                            <v-item v-slot:default="{ active, toggle }">
                                                                <v-img
                                                                        v-if="mediaItem.type < 2 && mediaItem.visible == 1"
                                                                        :src="mediaItem.link"
                                                                        height="120"
                                                                        class="text-right pa-2"
                                                                        @click="toggle"
                                                                >

                                                                    <v-overlay
                                                                            absolute
                                                                            :value=active
                                                                    >
                                                                        <v-btn
                                                                                small
                                                                                icon
                                                                                :dark=active
                                                                        >
                                                                            <v-icon>
                                                                                {{ active ? 'done' : 'keyboard' }}
                                                                            </v-icon>
                                                                        </v-btn>
                                                                    </v-overlay>
                                                                </v-img>
                                                                <v-card v-else flat
                                                                        @click="toggle">
                                                                    <v-card-text class="text-truncate pa-1">
                                                                        <p class="text-center mb-1">
                                                                            <v-icon large>insert_drive_file</v-icon>
                                                                        </p>
                                                                        <v-tooltip bottom>
                                                                            <template v-slot:activator="{ on }">
                                                                                <span v-on="on">{{mediaItem.caption}}</span>
                                                                            </template>
                                                                            <span>{{mediaItem.caption}}</span>
                                                                        </v-tooltip>
                                                                        <v-overlay
                                                                                absolute
                                                                                :value=active
                                                                        >
                                                                            <v-btn
                                                                                    small
                                                                                    icon

                                                                            >
                                                                                <v-icon>
                                                                                    {{ active ? 'done' : 'keyboard' }}
                                                                                </v-icon>
                                                                            </v-btn>
                                                                        </v-overlay>
                                                                    </v-card-text>

                                                                </v-card>
                                                            </v-item>
                                                        </v-flex>
                                                    </v-flex>
                                                </v-layout>
                                            </v-item-group>
                                        </v-container>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-tab-item>
                    </v-tabs>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout>
                        <v-flex xs12>
                            <v-card
                                    max-width="750"
                                    class="mx-auto"
                                    flat
                            >
                                <span>Выбранные файлы:</span>
                                <v-container
                                        grid-list-sm
                                        pa-1
                                >
                                    <v-layout wrap>
                                        <v-flex
                                                v-for="(selectedItem, index) in selectedItems"
                                                :key="selectedItem.id"
                                                xs2
                                                md2

                                        >
                                            <v-img
                                                    v-if="selectedItem.type < 2"
                                                    :src="selectedItem.link"
                                                    height="120"
                                                    class="text-right pa-2"
                                                    @click="selectMedia(null, index, 'deselect')"
                                            >
                                            </v-img>
                                            <v-card v-else flat @click="selectMedia(null, index, 'deselect')">
                                                <v-card-text class="text-truncate pa-1">
                                                    <p class="text-center mb-1">
                                                        <v-icon large>insert_drive_file</v-icon>
                                                    </p>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <span v-on="on">{{selectedItem.caption}}</span>
                                                        </template>
                                                        <span>{{selectedItem.caption}}</span>
                                                    </v-tooltip>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="confirmDialog"
                max-width="300"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2">Подтвердите удаление</v-card-title>

                <v-card-text>
                    Вы действительно хотите удалить?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            text
                            @click="confirmDialog = false"
                    >
                        Отмена
                    </v-btn>

                    <v-btn
                            color="error darken-1"
                            text
                            @click="removeSelectedMediaItems"
                    >
                        Подтверждаю
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import axios from 'axios'
import constConf from '../../../constconf.js'
import MediaLibraryToolbar from './media_library/MediaLibraryToolbar'
import { mapGetters } from 'vuex'
export default {
    name: 'AttachmentForm',
    components: {
        MediaLibraryToolbar
    },
    data() {
        return {
            removeMode: false,
            selected: [],
            confirmDialog: false,
            mediaType: 0,
            mediaTypes: [
                { name: 'Картинки', icon: 'photo_library' },
                { name: 'Видео', icon: 'movie' },
                { name: 'Документ', icon: 'insert_drive_file' }
            ],
            mediaItems: [[], [], []],
            selectedItems: []
        }
    },
    props: ['visible', 'messageModel'],
    methods: {
        selectMedia(typeMedia = null, index, action = 'select') {
            if (action === 'select' && [].concat(...this.selectedItems).length < 10) {
                this.selectedItems.push(this.mediaItems[typeMedia][index])
                this.mediaItems[typeMedia][index].show = 0
                this.$emit('updateAttachment', { selectedItems: this.selectedItems, saveMessage: true })
            }
            if (action === 'deselect') {
                typeMedia = this.selectedItems[index].type
                for (let i = 0; i < this.mediaItems[typeMedia].length; i++) {
                    if (this.mediaItems[typeMedia][i].id === this.selectedItems[index].id) {
                        this.mediaItems[typeMedia][i].show = 1
                    }
                }
                this.selectedItems.splice(index, 1)
                this.$emit('updateAttachment', { selectedItems: this.selectedItems, saveMessage: true })
            }
        },
        updateMediaInMessage() {
            this.selectedItems = []
            let attachments = this.messageModel.attachment !== null && this.messageModel.attachment !== undefined ? this.messageModel.attachment.split(',') : null
            if (attachments !== null) {
                for (let i = 0; i < 3; i++) {
                    for (let j = 0; j < this.mediaItems[i].length; j++) {
                        let show = 1
                        for (let k = 0; k < attachments.length; k++) {
                            if (attachments[k] === this.mediaItems[i][j].attachmentId) {
                                show = 0
                                this.selectedItems.push(this.mediaItems[i][j])
                                break
                            }
                        }
                        this.mediaItems[i][j].show = show
                    }
                }
                this.$emit('updateAttachment', { selectedItems: this.selectedItems, saveMessage: false })
            } else {
                for (let i = 0; i < 3; i++) {
                    for (let j = 0; j < this.mediaItems[i].length; j++) {
                        this.mediaItems[i][j].show = 1
                    }
                }
                this.$emit('updateAttachment', { selectedItems: [], saveMessage: false })
            }
        },
        updateAllLibrary() {
            this.mediaItems = [[], [], []]
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/medialibrary/all/' + this.$route.params['pathMatch']).then(response => {
                for (let i = 0; i < response.data.length; i++) {
                    response.data[i].show = 1
                    this.mediaItems[response.data[i].type].push(response.data[i])
                }
                this.updateMediaInMessage()
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        },
        removeSelectedMediaItems() {
            let data = []
            for (let i = 0; i < this.selected.length; i++) {
                data.push(this.mediaItems[this.mediaType][this.selected[i]].id)
                this.mediaItems[this.mediaType][this.selected[i]].visible = 0
            }
            axios.defaults.withCredentials = true
            axios.post(constConf.message.url + '/medialibrary/remove/' + this.$route.params['pathMatch'], data).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
            this.selected = []
            this.confirmDialog = false
        },
        sendNotification() {
            // document.location.href = 'https://vk.com/club' + 173744970
            let bot = this.bot(this.$route.params['pathMatch'])
            let url = 'https://vk.com/gim' + bot.group_id + '?sel=' + this.user.id
            // 'https://vk.com/write-' + bot.group_id, '_blank'
            window.open(url)
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/send/service-vk/' + 1 + '?bot_id=' + bot.id).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        }
    },
    computed: {
        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            user: 'user/user'
        })
    },
    watch: {
        show() {
            if (this.show) {
                this.updateMediaInMessage()
            }
        },
        messageModel() {
            this.updateMediaInMessage()
        },
        confirmDialog() {
            if (!this.confirmDialog) { this.selected = [] }
        }
    },
    created() {
        axios.defaults.withCredentials = true
        axios.get(constConf.message.url + '/medialibrary/all/' + this.$route.params['pathMatch']).then(response => {
            for (let i = 0; i < response.data.length; i++) {
                response.data[i].show = 1
                this.mediaItems[response.data[i].type].push(response.data[i])
            }
            this.updateMediaInMessage()
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get medialibrary ' + error)
        })
    }
}
</script>

<style scoped>
   a:hover {
        cursor: pointer;
        text-decoration: none;
        color:#000000;
    }
</style>
